import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';


const theme = createTheme({
   
    components: {
        MuiTextField: {
            defaultProps: {
                variant: 'standard',
                disableUnderline: true,
                fullWidth: true,
                autoComplete: false
            },
            styleOverrides: {
                root: {
                    backgroundColor: '#F9FAFB',
                    borderRadius: '8px',
                    padding: '8px',
                    boxSizing: 'border-box',
                    marginTop: '8px',
                    '& input[type=number]': {
                        '-moz-appearance': 'textfield'
                    },
                    '& input[type=number]::-webkit-outer-spin-button': {
                        '-webkit-appearance': 'none',
                        margin: 0
                    },
                    '& input[type=number]::-webkit-inner-spin-button': {
                        '-webkit-appearance': 'none',
                        margin: 0
                    }
                }
            }
        },
    }
})

export default theme;



export const TypographyDefault = styled(Typography)({
    fontSize: '14px',
    color: "black",
    fontWeight: "400"
})

export const PrimaryTypography = styled(Typography)({
    fontSize: '18px',
    color: "black",
    fontWeight: "600"
})

export const secondaryTypography = styled(Typography)({
    fontSize: '16px',
    color: "black",
    fontWeight: "600"
})



export const ErrorTypography = styled(Typography)({
    fontSize: '14px',
    color: "error",
    fontWeight: "400"
})

